import { render, staticRenderFns } from "./CMEditContactGroup.vue?vue&type=template&id=2c49b6db&"
import script from "./CMEditContactGroup.vue?vue&type=script&lang=js&"
export * from "./CMEditContactGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c49b6db')) {
      api.createRecord('2c49b6db', component.options)
    } else {
      api.reload('2c49b6db', component.options)
    }
    module.hot.accept("./CMEditContactGroup.vue?vue&type=template&id=2c49b6db&", function () {
      api.rerender('2c49b6db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contacts/CMEditContactGroup.vue"
export default component.exports